export default __webpack_public_path__ + "static/media/903.282f0106.gif";